import { BookOpen } from 'lucide-react';
import { PRODUCTS, productUnitShort } from '../game/constants.js';

function money(value) {
  return `$${Number(value || 0).toLocaleString()}`;
}

function PriceNote({ side, value, label, productId }) {
  if (value == null) return <span className="notebook-price muted">{side} —</span>;
  return (
    <span className="notebook-price">
      {side} {money(value)}/{productUnitShort(productId)}
      {label && <em> · {label}</em>}
    </span>
  );
}

function DealerNote({ entry }) {
  const lines = Array.isArray(entry.dealerLines) ? entry.dealerLines : [];
  return (
    <div className="notebook-dealer-lines">
      {lines.length ? lines.map((line, index) => (
        <div className="notebook-dealer-note" key={`${line.label}-${index}`}>
          <span>{line.label || 'Offer'}</span>
          <strong>{line.value || '—'}</strong>
          {line.detail && <small>{line.detail}</small>}
        </div>
      )) : <p className="notebook-dealer-empty">No useful quote was available when you stopped by.</p>}
    </div>
  );
}

export function MarketNotebook({ entries = [], className = '' }) {
  return (
    <section className={`market-notebook-view ${className}`.trim()} aria-labelledby="market-notebook-title">
      <header className="notebook-view-heading">
        <span><BookOpen aria-hidden="true" /> MARKET NOTES</span>
        <h2 id="market-notebook-title">Visited-market notebook</h2>
        <p>Only places you have actually visited make it into this battered little book. Prices and dealer offers stay dated until you revisit.</p>
      </header>
      <div className="market-notebook-canvas">
        <div className="notebook-right-page">
          <div className="notebook-page-title">
            <strong>Prices I saw</strong>
            <small>buy low · sell high · don’t get robbed</small>
          </div>
          {entries.length > 0 ? (
            <div className="notebook-entry-list">
              {entries.map((entry) => {
                const dealer = entry.kind === 'dealer';
                return (
                  <article className={`notebook-entry ${dealer ? 'dealer-entry' : 'market-entry'}`} key={entry.locationId}>
                    <header>
                      <div><em className="notebook-kind">{dealer ? 'DEALER' : 'MARKET'}</em><h3>{entry.locationName}</h3></div>
                      <span>last seen · day {entry.day}</span>
                    </header>
                    {dealer ? <DealerNote entry={entry} /> : (
                      <div className="notebook-products">
                        {PRODUCTS.map((product) => {
                          const buy = entry.buyPrices?.[product.id];
                          const sell = entry.sellPrices?.[product.id];
                          if (buy == null && sell == null) return null;
                          return (
                            <div className="notebook-product-note" key={product.id}>
                              <strong>{product.name}</strong>
                              <PriceNote side="buy" value={buy} label={entry.buyLabels?.[product.id]} productId={product.id} />
                              <PriceNote side="sell" value={sell} label={entry.sellLabels?.[product.id]} productId={product.id} />
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </article>
                );
              })}
            </div>
          ) : (
            <div className="notebook-empty">
              <strong>Nothing useful yet.</strong>
              <p>Visit a market or specialty dealer and I’ll scribble the last-seen quote here.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
